import { createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { InsuranceCarrier } from '@core/models/insurance-carrier';
import { HttpErrorResponse } from '@angular/common/http';
import { CustomError } from '@orthofi/ngx-error-handler';
import * as InsuranceCarrierActions from './insurance-carrier.actions';

/** A string used to identify this feature's state object in the reducer. */
export const featureKey = 'insuranceCarriers';

export const adapter: EntityAdapter<InsuranceCarrier> = createEntityAdapter<InsuranceCarrier>( {
  selectId: ( insurance ) => insurance.InsuranceCarrierId,
  sortComparer: ( a, b ) => a.InsuranceCarrierName.localeCompare( b.InsuranceCarrierName )
});

/**
 * The standard Entity state map and entity list augmented with additional
 * attributes related to the API request status. This map represents the full
 * list of OrthoFi insurance carriers available for use.
 */
export interface InsuranceCarrierState extends EntityState<InsuranceCarrier> {
  carrierError: Error | HttpErrorResponse | CustomError;
  /**
   * A boolean set to true when there is a request to load the list of
   * insurance carriers in progress.
   */
  isCarrierLoading: boolean;
}

/** The initial state of the entity combined with the initial state of our added API status attributes. */
export const initialState: InsuranceCarrierState = adapter.getInitialState( {
  isCarrierLoading: false,
  carrierError: undefined
});

export const reducer = createReducer(
  initialState,
  on(InsuranceCarrierActions.loadInsuranceCarriers,
    ( state, action ) => ( {
      ...state,
      isCarrierLoading: true
    })
  ),
  on(
    InsuranceCarrierActions.loadInsuranceCarriersSuccess,
    ( state, action ) => adapter.setAll( action.insuranceCarriers, {
      ...state,
      isCarrierLoading: false,
      carrierError: undefined
    } )
  ),
  on(
    InsuranceCarrierActions.loadInsuranceCarriersFail,
    ( state, action ) => ( {
      ...state,
      isCarrierLoading: false,
      carrierError: action.error
    })
  ),
);
